import request from '../../js/lib/request';
import envVar from '../../js/lib/envVar';
import urlVars from '../../js/lib/urlVars';
import currentLang from '../../js/lib/currentLang';

const magazineFeed = document.getElementById('MagazineFeed');

const options = {
	headers: {
		"content-type": "application/json; charset=utf-8"
	}
};

if (magazineFeed) {
	const initUrl = envVar({
		backendPath: '/MagazineHomePage/ArticleFeed',
	});
	request().get(initUrl + "?categories=" + magazineFeed.dataset.categories + "&lang=" + currentLang() + "&pageid=" + magazineFeed.dataset.pageid).then(function (response) {

		const magazineVue = new Vue({
			el: '#MagazineFeed',
			data: {
				collection: '',
				selectedIndex: 0,
				currentPageIndex: 0,
				lastPageIndex: 0,
				pageList: [1],
			},
			mounted: function () {
				const self = this;

				self.collection = response;
				self.checkUrl();

			},
			methods: {

				loadArticles: function (index, event) {
					const self = this;
					self.selectedIndex = index;
					self.resetPaginationData();
					const buttonCollection = document.getElementsByClassName('magazinearticlefeednav');

					for (var i = 0; i < buttonCollection.length; i++) {
						if (i == self.selectedIndex) {
							buttonCollection[i].setAttribute('selected', true);
						}
						else {
							buttonCollection[i].removeAttribute('selected');
						}
					}

					if (event) {
						if (window.history.pushState)
							window.history.pushState({ 'html': response }, '', '?featured=' + index);
					}

				},
				jumpToPage: function (index){
					const self = this;
					self.currentPageIndex = index;
					self.updatePaginationData();	

				},
				resetPaginationData: function (){
					const self = this;
					self.currentPageIndex = 1;
					self.lastPageIndex = Math.ceil(self.collection[self.selectedIndex].length/8.0)
					self.updatePaginationData();
				},
				updatePaginationData: function(){
					const self = this;
					self.pageList = [];
					if (self.lastPageIndex > 1) {
						if (self.lastPageIndex > self.currentPageIndex) {
							self.pageList[0] = self.currentPageIndex;
							self.pageList[1] = self.currentPageIndex + 1;
							if (self.currentPageIndex + 2 <= self.lastPageIndex)
								self.pageList[2] = self.currentPageIndex + 2;
						}
						else {
							if(self.currentPageIndex - 2 >= 1){
								self.pageList.push(self.currentPageIndex - 2);
							}
							self.pageList.push(self.currentPageIndex - 1);
							self.pageList.push(self.currentPageIndex);
						}
					}
				},
				



				checkUrl: function () {
					const self = this;

					// check featured url var
					var qs = urlVars();
					if (qs['featured'])
						self.loadArticles(qs['featured']);
					else
						self.loadArticles(0);
				},


			}
		});
	});
}



// WEBPACK FOOTER //
// ../components/magazine/magazine-feed.js